import { greekMessages } from '@/plugins/yup-localization';
import { BaseSchemaBuilder } from '@/views/checkouts/schemas/baseSchema';
import { isValidDate, singleAlphabet } from '@/views/checkouts/schemas/validators';
import * as yup from 'yup';

export const sharedInterlifeFields = (
    firstDriverAdditionalPremiumAge,
    secondDriverAdditionalPremiumAge,
    firstDriverAdditionalPremiumLicenseYears,
    secondDriverAdditionalPremiumLicenseYears,
    legalEntity,
    secondDriver,
    discountEntity,
    vehicleType
) => {
    let schema = {
        ...BaseSchemaBuilder(true, false, legalEntity, !legalEntity, discountEntity),
        nationality: yup.string().required(),
        copy_address: yup.boolean().required(),
        contact_address: yup.string().when('copy_address', {
            is: false,
            then: s => s.required(),
            otherwise: s => s.notRequired(),
        }),
        contact_postcode: yup.string().when('copy_address', {
            is: false,
            then: s => s.required(),
            otherwise: s => s.notRequired(),
        }),
    };

    if (firstDriverAdditionalPremiumLicenseYears) {
        schema = {
            ...schema,
            licenseIssueDate: yup.object({
                day: yup.string().required(),
                month: yup.string().required(),
                year: yup.string().required(),
            }).test('isValidDate', greekMessages.mixed.isValidDate, isValidDate).required(),
        };
    }

    if (secondDriverAdditionalPremiumLicenseYears) {
        schema = {
            ...schema,
            licenseIssueDate2: yup.object().when('only_driver', {
                is: false,
                then: s => s.shape({
                    day: yup.string().required(),
                    month: yup.string().required(),
                    year: yup.string().required(),
                }).test('isValidDate', greekMessages.mixed.isValidDate, isValidDate)
            }),
        };
    }

    if (!legalEntity) {
        schema = {
            ...schema,
            name: singleAlphabet(schema.name),
            surname: singleAlphabet(schema.surname),
        };
    }

    return schema;
};

export const sharedInterlifeSchemaBuilder = (...args) => yup.object(sharedInterlifeFields(...args));
export default sharedInterlifeSchemaBuilder;
